import {WasteKey} from './../Constants/IP/WasteKeyLabel';
import {RawMaterialKey} from './../Constants/Products/RawMaterialKeyAndLabel';
const nestedArray = (nested: string): string[] => {
  switch (nested) {
    case WasteKey.disposalMethodData:
      return [
        WasteKey.disposalKey.landfill,
        WasteKey.disposalKey.incineration,
        WasteKey.disposalKey.recycling,
        WasteKey.disposalKey.reclaimed,
        WasteKey.disposalKey.reused,
        WasteKey.disposalKey.notTreated
      ];
    case RawMaterialKey.RECYCLE_DATA:
      return [
        RawMaterialKey.RECYCLE.recycle,
        RawMaterialKey.RECYCLE.reuse,
        RawMaterialKey.RECYCLE.fresh
      ];
    default:
      return [];
  }
};

export default nestedArray;
